

































import {
  Component,
  Vue,
  Prop,
} from 'vue-property-decorator';
import { FitIcon, FitLayout } from '@tencent/wphk-ui';

/** icon信息, 同icon组件参数 */
type MsgIconInfo = string | {
  icon: string;
  namespace?: string;
  prefix?: string;
};

@Component({
  components: {
    FitLayout,
    FitIcon,
  },
})
export default class FitMsg extends Vue {
  /** Icon信息 */
  @Prop({ default: 'info' }) icon!: MsgIconInfo;
  /** 标题 */
  @Prop({ default: '' }) title!: string;
  /** 描述 */
  @Prop({ default: '' }) desc!: string;
  /** 标题颜色 */
  @Prop({ default: 'rgba(0, 0, 0)' }) titleColor!: string;
  /** 是否有传入描述插槽 */
  get isHasSlotDesc() {
    return !!this.$slots.desc;
  }
  get iconInfo(): MsgIconInfo {
    if (typeof this.icon === 'string') {
      return {
        icon: this.icon,
      };
    }
    return this.icon;
  }
}
